import { UniversityData } from './';

export const universitySortByRank = (univ1: UniversityData, univ2: UniversityData) => {
  // handling rank undefined case
  if (!univ1.universityCountryRank && !univ2.universityCountryRank) {
    return 0;
  }
  if (!univ1.universityCountryRank) {
    return 1;
  }
  if (!univ2.universityCountryRank) {
    return -1;
  }
  return univ1.universityCountryRank - univ2.universityCountryRank;
};

export const universitySortByName = (univ1: UniversityData, univ2: UniversityData) => {
  // handling name undefined case
  if (!univ1.name && !univ2.name) {
    return 0;
  }
  if (!univ1.name) {
    return 1;
  }
  if (!univ2.name) {
    return -1;
  }
  if (univ1.name < univ2.name) {
    return -1;
  }
  if (univ1.name > univ2.name) {
    return 1;
  }
  return 0;
};
